define('views/pages/wishlist/wishes/table-row',['require','jquery','views/base/view','views/dialog','text!templates/pages/wishlist/wishes/table-row.ejs','models/pages/wishlist/wishes/modal/index','views/pages/wishlist/wishes/modal/index'],function(require) {
    'use strict';

    var $ = require('jquery'),
        View = require('views/base/view'),
        Dialog = require('views/dialog'),
        template = require('text!templates/pages/wishlist/wishes/table-row.ejs'),
        WishlistModalModel = require('models/pages/wishlist/wishes/modal/index'),
        WishListModalView = require('views/pages/wishlist/wishes/modal/index');

    var WishlistItemView = View.extend({
        autoRender: true,
        template: template,
        tagName: 'tr',
        events: {
            'click .btn-success': 'openEditModal',
            'click .btn-danger': 'deleteItem'
        },
        listen: {
            'change model': 'render'
        },

        openEditModal: function() {
            var model = this.model;

            var modalModel = new WishlistModalModel({ id: model.get('id') });

            this.subview('editModal', new WishListModalView({ model: modalModel }));

            modalModel.load();

            modalModel.on('saved', function(action, cancel) {
                model.collection.fetch();

                modalModel.dispose();
            });
        },

        deleteItem: function() {
            var model = this.model;

            Dialog.show('Удаление', 'Вы действительно хотите удалить эту запись?', Dialog.Buttons.YesNo)
                .attach(this)
                .submit(function() {
                    model.destroy();
                });

        },

        render: function() {
            this.destroyTooltip();
            View.prototype.render.apply(this, arguments);
            this.createToolTip();
        },

        createToolTip: function() {
            this.$('span[data-toggle=tooltip]').tooltip({ container: 'body', placement: 'bottom' });
        },

        destroyTooltip: function() {
            this.$('span[data-toggle=tooltip]').tooltip('destroy');
        },

        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        }
    });

    return WishlistItemView;
});

